import React, { createContext, useReducer, useContext } from 'react';
import { getVendingMachineMetaObject, fetchLocation } from '../api/storefrontApi.jsx';
import { update } from 'lodash';
import { ProductCoilSettingContext } from './ProductCoilSettingContext.jsx';

const initialState = {
    // your initial state
};

const reducer = (state, action) => {
    switch (action.type) {
        // your reducer cases
        case 'UPDATE_META_OBJECT':
            return {
                ...state,
                metaObjectId: action.payload.metaObject.id,
                metaObject: action.payload.metaObject,
                ...action.payload.data
            };
        default:
            return state;
    }
};

const bannerContentHandler = (edges) => {
    let bannerContents = edges.map(({ node }) => {
        const banner = node;
        const bannerContent = {
            active: banner.fields[0].value,
            url: banner.fields[1].reference.image.url,
            mediaContentType: banner.fields[1].reference.mediaContentType,
        };
        return bannerContent;
    });
    return bannerContents
}

const productsResultHandler = (edges) => {
    let products = [];
    products = edges.map(({ node }) => {
        const productVariant = node
        const productData = {
            id: productVariant.id,
            imgSrc: productVariant.product.featuredImage.originalSrc,
            imgAltText: productVariant.product.featuredImage.altText,
            title: productVariant.product.title,
            priceObject: productVariant.price,
            price: productVariant.price.amount,
            currencyCode: productVariant.price.currencyCode,
            sku: productVariant.sku,
            dashboardProductId: productVariant.product?.metafields[0]?.value,
            availableForSale: productVariant.availableForSale,
            quantityAvailable: productVariant.quantityAvailable
        };
        return productData
    });
    return products
}

export const StorefrontContext = createContext(initialState);

export const StorefrontProvider = ({ children }) => {
    const { updateProductCoilSetting } = useContext(ProductCoilSettingContext);

    const [state, dispatch] = useReducer(reducer, initialState);

    const fetchMetaObject = () => {
        getVendingMachineMetaObject().then((data) => {
            let customData = {}
            data.data.metaobject.fields.map(({ key, ...fields }) => {
                switch (key) {
                    case 'coil_setting':
                        console.log('coil_setting found in metaobject');
                        let coilSettings = JSON.parse(fields.value)
                        customData[key] = coilSettings
                        updateProductCoilSetting(coilSettings.value, coilSettings?.update_at, true);
                        break;
                    case 'products':
                        if (fields.references?.edges) {
                            customData[key] = productsResultHandler(fields.references.edges);
                        }
                        break;
                    case 'banner_object':
                        if (fields.references?.edges) {
                            customData[key] = bannerContentHandler(fields.references.edges);
                        }
                        break;
                    case 'port_no':
                        localStorage.setItem('port_no', fields.value);
                    default:
                        customData[key] = fields.value
                }
            });
            dispatch({ type: 'UPDATE_META_OBJECT', payload: { data: customData, metaObject: data.data.metaobject } });
            // return data;
        }).catch((error) => {
            console.error('Error fetching all storefront data:', error);
        });
    }

    const fetchLocationId = () => {
        fetchLocation().then((data) => {
            console.log('Location data:', data);
            localStorage.setItem('locationId', data.data.locations.edges[0].node.id);
        }).catch((error) => {
            console.error('Error fetching location data:', error);
        });

    }
    return (
        <StorefrontContext.Provider value={{ state, fetchMetaObject, fetchLocationId }}>
            {children}
        </StorefrontContext.Provider>
    );
};
